export var TREATMENTS;

(function (TREATMENTS) {
  TREATMENTS["corresponsalWompiEnabled"] = "corresponsalWompiEnabled";
  TREATMENTS["enablePseAmountOptions"] = "enablePseAmountOptions";
  TREATMENTS["disableAppSucursalBanColombia"] = "disableAppSucursalBanColombia";
  TREATMENTS["enableDruoSection"] = "enableDruoSection";
  TREATMENTS["enablePSEPayment"] = "enablePSEPayment";
  TREATMENTS["enableCorresponsalPayment"] = "enableCorresponsalPayment";
  TREATMENTS["enableBannerHowToPayTwoEmbedded"] = "enableBannerHowToPayTwoEmbedded";
  TREATMENTS["removeKushkiPaymentMethodWeb"] = "removeKushkiPaymentMethodWeb";
  TREATMENTS["enableBannerHowToPayTwoEmbeddedBR"] = "enableBannerHowToPayTwoEmbeddedBR";
  TREATMENTS["preApprovalVersion"] = "preApprovalVersion";
  TREATMENTS["unavailableBanks"] = "unavailableBanks";
  TREATMENTS["enableWompiWidgetIntegritySignature"] = "enableWompiWidgetIntegritySignature";
  TREATMENTS["enableEmbeddedWompiWidgetIntegritySignature"] = "enableEmbeddedWompiWidgetIntegritySignature";
})(TREATMENTS || (TREATMENTS = {}));